import { without } from "lodash-es"
import {
  SupportedExpectationList,
  SupportedExpectation,
} from "src/global/schemas/expectations/expectation-metadata-utils.ts"

export const SupportedExpectationCards = without(SupportedExpectationList, "unexpectedRowsExpectation") as Exclude<
  SupportedExpectation,
  "unexpectedRowsExpectation"
>[]
